import { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ProductByShop from "./ProductByShop";

const initialFormData = {
    activity_type: "SHIPPING_DISCOUNT",
    title: "",
    product_level: "SHOP",
    shipping_discount: {
        threshold_type: "NO_THRESHOLD",
        discount_type: "FREE_SHIPPING",
    },
    tiers: [{
        threshold_type: "NO_THRESHOLD",
        discount_type: "PERCENTAGE_OFF",
    }],
    duration_type: "NORMAL",
    begin_time: new Date(),
    end_time: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
    check_all_products: true,
    shops_selected: [],
    products_selected: []
};

function ModalEditCampaign({ onSubmit, shops, edit_data, setEditData }) {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation();
    const [formData, setFormData] = useState(initialFormData);

    useEffect(() => {
        if (edit_data) {
            setFormData((prev) => ({
                ...prev,
                ...edit_data,
                tiers: edit_data?.bmsm_discount,
                begin_time: new Date(edit_data?.begin_time),
                end_time: new Date(edit_data?.end_time),
                check_all_products: edit_data?.product_level === "SHOP" ? true : false,
                shops_selected: [edit_data?.shop_id],
                products_selected: edit_data?.products
            }));
            setIsOpen(true);
        }
    }, [edit_data]);

    const onClose = () => {
        setEditData(null);
        setIsOpen(false);
    };

    const handleSubmit = () => {
        onSubmit(formData, onClose);
        // onClose();
    };

    const addTier = () => {
        setFormData((prev) => ({ ...prev, tiers: [...prev.tiers, { threshold_type: "NO_THRESHOLD", discount_type: "PERCENTAGE_OFF" }] }));
    };

    const removeTier = (index) => {
        const newTiers = [...formData?.tiers];
        newTiers.splice(index, 1);
        setFormData((prev) => ({ ...prev, tiers: newTiers }));
    };

    const handleChangeForm = (e) => {
        if (e.target.name === "title" || e.target.name === "duration_type") {
            setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
        } else if (e.target.name === "product_level") {
            setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value, check_all_products: e.target.value === "SHOP" ? true : false }));
        } else {
            setFormData((prev) => ({ ...prev, shipping_discount: { ...prev.shipping_discount, [e.target.name]: e.target.value } }));
        }
    };

    return (
        <Fragment>
            <Modal
                centered={true}
                // fullscreen={true}
                size="xl"
                toggle={() => {
                    onClose();
                }}
                isOpen={isOpen}
            >
                <div className="modal-header">
                    <h3>{t("Create New Campaign")}</h3>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <i
                            className="ki-outline ki-cross fs-1"
                            onClick={() => {
                                onClose();
                            }}
                        ></i>
                    </div>
                </div>
                <ModalBody>
                    <h3 className="mb-2">{t("Campaign Type")}</h3>
                    <div className="d-flex justify-content-around mb-5">
                        <div className={formData?.activity_type === "SHIPPING_DISCOUNT" ? "d-flex justify-content-start align-items-center border p-5 btn border-danger shadow" : "d-flex justify-content-start align-items-center border p-5 btn"} onClick={() => setFormData((prev) => ({
                            ...prev,
                            activity_type: "SHIPPING_DISCOUNT"
                        }))}>
                            <div>
                                <i className="ki-outline ki-delivery fs-1"></i>
                            </div>
                            <div className="d-flex align-items-start flex-column ms-2">
                                <span>
                                    <strong>{t("Free Shipping")}</strong>
                                </span>
                                <span>
                                    {t("Offer free shipping above a threshold")}
                                </span>
                            </div>
                        </div>
                        <div className={formData?.activity_type === "BUY_MORE_SAVE_MORE" ? "d-flex justify-content-start align-items-center border p-5 btn border-danger shadow" : "d-flex justify-content-start align-items-center border p-5 btn"} onClick={() => setFormData((prev) => ({
                            ...prev,
                            activity_type: "BUY_MORE_SAVE_MORE"
                        }))}>
                            <div>
                                <i className="ki-outline ki-discount fs-1"></i>
                            </div>
                            <div className="d-flex align-items-start flex-column ms-2">
                                <span>
                                    <strong>{t("Buy More Save More")}</strong>
                                </span>
                                <span>
                                    {t("Tiered discounts based on quantity")}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="form-group row mb-5">
                        <div className="col-md-6">
                            <div className="form-group mb-2">
                                <label className="">
                                    <span className="required">{t("Campaign Name")}</span>
                                </label>
                                <input className="form-control" name="title" value={formData?.title}
                                    onChange={handleChangeForm}
                                ></input>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group mb-2">
                                <label className="">
                                    <span className="required">{t("Product Level")}</span>
                                </label>
                                <select className="form-control" name="product_level" value={formData?.product_level}
                                    onChange={handleChangeForm}>
                                    <option value="SHOP">{t("SHOP")}</option>
                                    {/* <option value="PRODUCT">{t("PRODUCT")}</option> */}
                                </select>
                            </div>
                        </div>
                    </div>

                    {formData?.activity_type === "SHIPPING_DISCOUNT" &&
                        <div className="form-group row mb-5">
                            <div className={formData?.shipping_discount?.threshold_type !== "NO_THRESHOLD" && formData?.shipping_discount?.threshold_type ? "col-md-3" : "col-md-6"}>
                                <div className="form-group mb-2">
                                    <label className="required">{t("Threshold Type")}</label>
                                    <select className="form-control" name="threshold_type" value={formData?.shipping_discount?.threshold_type}
                                        onChange={handleChangeForm}>
                                        <option value="NO_THRESHOLD">{t("NO_THRESHOLD")}</option>
                                        {formData?.product_level === "SHOP" && formData?.product_level &&

                                            <>
                                                <option value="MINIMAL_ITEM_QUANTITY">{t("MINIMAL_ITEM_QUANTITY")}</option>
                                                <option value="MINIMAL_ORDER_AMOUNT">{t("MINIMAL_ORDER_AMOUNT")}</option>
                                            </>
                                        }

                                    </select>
                                </div>
                            </div>
                            {formData?.shipping_discount?.threshold_type !== "NO_THRESHOLD" && formData?.shipping_discount?.threshold_type &&
                                <div className="col-md-3">
                                    <div className="form-group mb-2">
                                        <label className="required">{t("Threshold Value")}</label>
                                        <input className="form-control" name="threshold_value" type="number" value={formData?.shipping_discount?.threshold_value}
                                            onChange={handleChangeForm}></input>
                                    </div>
                                </div>
                            }
                            <div className={formData?.shipping_discount?.discount_type !== "FREE_SHIPPING" && formData?.shipping_discount?.discount_type ? "col-md-3" : "col-md-6"}>
                                <div className="form-group mb-2">
                                    <label className="required">{t("Discount Type")}</label>
                                    <select className="form-control" name="discount_type" value={formData?.shipping_discount?.discount_type}
                                        onChange={handleChangeForm}>
                                        <option value="FREE_SHIPPING">{t("FREE_SHIPPING")}</option>
                                        <option value="DISCOUNT_SHIPPING_FEE">{t("DISCOUNT_SHIPPING_FEE")}</option>
                                    </select>
                                </div>
                            </div>
                            {formData?.shipping_discount?.discount_type !== "FREE_SHIPPING" && formData?.shipping_discount?.discount_type &&
                                <div className="col-md-3">
                                    <div className="form-group mb-2">
                                        <label className="required">{t("Discount Value")}</label>
                                        <input className="form-control" name="discount_value" type="number" value={formData?.shipping_discount?.discount_value}
                                            onChange={handleChangeForm}></input>
                                    </div>
                                </div>
                            }
                        </div>
                    }

                    {formData?.activity_type === "BUY_MORE_SAVE_MORE" &&
                        <div className="card form-group row mb-5 shadow">
                            <div className="col-md-12 p-5">
                                <div className="form-group mb-2">
                                    {/* <label className="required">Tier Information:</label> */}
                                    <div>
                                        {/* Loop through tiers */}
                                        {formData?.tiers.map((tier, tierIndex) => (
                                            <div key={tierIndex} className="tier-section mb-4">
                                                <h5>Tier {tierIndex + 1}</h5>
                                                <div className="form-group row mb-5">
                                                    <div className="col-md-3">
                                                        <label className="required">{t("Threshold Type")}</label>
                                                        <select className="form-control" name={`threshold_type_${tierIndex}`} onChange={(e) => {
                                                            const updatedTiers = [...formData?.tiers];
                                                            updatedTiers[tierIndex].threshold_type = e.target.value;
                                                            setFormData((prev) => ({ ...prev, tiers: updatedTiers }));
                                                        }}>
                                                            {/* <option value="NO_THRESHOLD">{t("NO_THRESHOLD")}</option> */}
                                                            <option value="MINIMAL_ITEM_QUANTITY">{t("MINIMAL_ITEM_QUANTITY")}</option>
                                                            <option value="MINIMAL_ORDER_AMOUNT">{t("MINIMAL_ORDER_AMOUNT")}</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label className="required">{t("Threshold Value")}</label>
                                                        <input
                                                            className="form-control"
                                                            name={`threshold_value_${tierIndex}`}
                                                            type="number"
                                                            value={tier.threshold_value || ""}
                                                            onChange={(e) => {
                                                                const updatedTiers = [...formData?.tiers];
                                                                updatedTiers[tierIndex].threshold_value = e.target.value;
                                                                setFormData((prev) => ({ ...prev, tiers: updatedTiers }));
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label className="required">{t("Discount Type")}</label>
                                                        <select
                                                            className="form-control"
                                                            name={`discount_type_${tierIndex}`}
                                                            onChange={(e) => {
                                                                const updatedTiers = [...formData?.tiers];
                                                                updatedTiers[tierIndex].discount_type = e.target.value;
                                                                setFormData((prev) => ({ ...prev, tiers: updatedTiers }));
                                                            }}
                                                        >
                                                            <option value="PERCENTAGE_OFF">{t("PERCENTAGE_OFF")}</option>
                                                            <option value="AMOUNT_OFF">{t("AMOUNT_OFF")}</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label className="required">{t("Discount Value")}</label>
                                                        <input
                                                            className="form-control"
                                                            name={`discount_value_${tierIndex}`}
                                                            type="number"
                                                            value={tier.discount_value || ""}
                                                            onChange={(e) => {
                                                                const updatedTiers = [...formData?.tiers];
                                                                updatedTiers[tierIndex].discount_value = e.target.value;
                                                                setFormData((prev) => ({ ...prev, tiers: updatedTiers }));
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                {/* Button to remove this tier */}
                                                {formData?.tiers.length > 1 && (
                                                    <button
                                                        className="btn btn-sm btn-danger"
                                                        onClick={() => removeTier(tierIndex)}
                                                    >
                                                        {t("Remove Tier")}
                                                    </button>
                                                )}
                                            </div>
                                        ))}

                                        {/* Button to add a new tier */}
                                        {formData?.tiers.length < 2 && <button
                                            className="btn btn-sm btn-success"
                                            onClick={addTier}
                                        >
                                            {t("Add Tier")}
                                        </button>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    <div className="form-group row mb-5">
                        <div className="col-md-4">
                            <label className="required">{t("Duration Type")}</label>
                            <select className="form-control" name="duration_type" value={formData?.duration_type}
                                onChange={handleChangeForm}>
                                <option value="NORMAL">{t("NORMAL")}</option>
                                {formData?.activity_type === "SHIPPING_DISCOUNT" && <option value="INDEFINITE">{t("INDEFINITE")}</option>}
                            </select>
                        </div>
                        <div className="col-md-4">
                            <label>{t("Begin time")}</label>
                            <div className="al-form-input-date w-100">
                                <DatePicker
                                    showTimeSelect
                                    timeIntervals={1}
                                    dateFormat="dd/MM/y HH:mm:ss"
                                    timeFormat="HH:mm"
                                    className="form-control w-100"
                                    selected={formData?.begin_time}
                                    onChange={(date) => setFormData((prev) => ({ ...prev, begin_time: date }))}
                                />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <label>{t("End time")}</label>
                            <div className="al-form-input-date w-100">
                                <DatePicker
                                    showTimeSelect
                                    timeIntervals={1}
                                    dateFormat="dd/MM/y HH:mm:ss"
                                    timeFormat="HH:mm"
                                    className="form-control w-100"
                                    selected={formData?.end_time}
                                    onChange={(date) => setFormData((prev) => ({ ...prev, end_time: date }))}
                                />
                            </div>
                        </div>
                    </div>
                    {/* Remaining fields */}
                    <ProductByShop shops={shops} formData={formData} setFormData={setFormData} />
                </ModalBody>
                <ModalFooter>
                    <button
                        type="reset"
                        id="kt_modal_users_search_reset"
                        data-bs-dismiss="modal"
                        className="btn btn-active-light me-3"
                        onClick={() => {
                            onClose();
                        }}
                    >
                        {t("Cancel")}
                    </button>
                    <button
                        onClick={handleSubmit}
                        type="submit"
                        id="kt_modal_users_search_submit"
                        className="btn btn-primary"
                    >
                        {t("Save")}
                    </button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ModalEditCampaign);
